import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function PricingSection() {
  const {
    ref,
    isRevealed
  } = useScrollReveal();
  return <section id="pricing" className="py-24 md:py-32 relative" data-id="element-173">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[600px] h-[600px] bg-[radial-gradient(circle,rgba(201,168,76,0.08)_0%,transparent_70%)] pointer-events-none z-0" data-id="element-174" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-175">
        <div ref={ref} className={`text-center mb-16 transition-all duration-1000 ${isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-176">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-177">
            Simple, Transparent <span className="text-[#c9a84c]" data-id="element-178">Pricing</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-179">
            Choose the perfect plan for your needs. No hidden costs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center max-w-6xl mx-auto" data-id="element-180">
          <PricingCard title="Starter" price="150€" features={['One Page Design', 'Mobile Responsive', 'Contact Form', 'Basic SEO', '3 Days Delivery']} delay={0} data-id="element-181" />
          <PricingCard title="Standard" price="200€" features={['Multi-Page Structure', 'Premium Animations', 'Advanced SEO', 'Social Media Integration', 'Analytics Dashboard', '48 Hours Delivery']} highlighted={true} delay={200} data-id="element-182" />
          <PricingCard title="Premium" price="350€" features={['E-commerce Ready', 'Custom Blog', 'Priority Support', 'Logo Design Included', 'Newsletter Setup', '5 Days Delivery']} delay={400} data-id="element-183" />
        </div>
      </div>
    </section>;
}
function PricingCard({
  title,
  price,
  features,
  highlighted = false,
  delay
}: {
  title: string;
  price: string;
  features: string[];
  highlighted?: boolean;
  delay: number;
}) {
  const {
    ref,
    isRevealed
  } = useScrollReveal();
  return <div ref={ref} style={{
    transitionDelay: `${delay}ms`
  }} className={`relative p-8 rounded-xl transition-all duration-700 transform ${isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'} ${highlighted ? 'bg-[#0a0a0a] border-2 border-[#c9a84c] shadow-[0_0_40px_-10px_rgba(201,168,76,0.2)] scale-105 z-10' : 'bg-[#080808] border border-white/10 hover:border-[#c9a84c]/50'}`} data-id="element-184">
      {highlighted && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#c9a84c] text-black text-xs font-bold px-4 py-1 rounded-full uppercase tracking-widest" data-id="element-185">
          Most Popular
        </div>}

      <h3 className="text-xl font-medium text-gray-300 mb-2" data-id="element-186">{title}</h3>
      <div className="flex items-baseline mb-6" data-id="element-187">
        <span className={`text-4xl font-bold ${highlighted ? 'text-[#c9a84c]' : 'text-white'}`} data-id="element-188">
          {price}
        </span>
        <span className="text-gray-500 ml-2 text-sm" data-id="element-189">/one-time</span>
      </div>

      <ul className="space-y-4 mb-8" data-id="element-190">
        {features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-191">
            <Check className={`h-5 w-5 flex-shrink-0 ${highlighted ? 'text-[#c9a84c]' : 'text-gray-500'}`} data-id="element-192" />
            <span className="text-gray-300 text-sm" data-id="element-193">{feature}</span>
          </li>)}
      </ul>

      <a href="https://wa.me/660960231920?text=hi%20i%20want%20the%20200%E2%82%AC%20ai%20website%20package.%20please%20send%20me%20the%20next%20steps." target="_blank" rel="noopener noreferrer" className={`w-full flex items-center justify-center py-3 rounded font-bold text-sm uppercase tracking-widest transition-all duration-300 ${highlighted ? 'bg-[#c9a84c] text-black hover:shadow-[0_0_20px_rgba(201,168,76,0.5)]' : 'border border-white/20 text-white hover:border-[#c9a84c] hover:text-[#c9a84c]'}`} data-id="element-194">
        Select Plan
      </a>
    </div>;
}